import Ajv from 'ajv';
import * as SessionScheme from './scheme.json';

const ajv = new Ajv();
export const SessionValidator = ajv.compile(SessionScheme);
